import { createColumnHelper } from "@tanstack/react-table";
import { qtyDisplay } from "@icraftx/shared/v1";
import { DocNumberLink } from "@/modules/core/components/DocNumberLink";
import type { DeskTableFeatures } from "@/modules/shell/data-table";
import type { ConversionRow } from "@/shared/api/conversions";

const columnHelper = createColumnHelper<DeskTableFeatures, ConversionRow>();

export function conversionHistoryColumns(companySlug: string) {
  return columnHelper.columns([
    columnHelper.accessor("number", {
      id: "number",
      header: "Number",
      size: 120,
      cell: (info) => (
        <DocNumberLink
          to={`/c/${companySlug}/inventory/conversions/${info.row.original.id}`}
        >
          {info.getValue()}
        </DocNumberLink>
      ),
    }),
    columnHelper.accessor("qtyFrom", {
      id: "qtyFrom",
      header: "From qty",
      size: 100,
      enableSorting: false,
      cell: (info) => (
        <span className="font-mono tabular-nums">
          {qtyDisplay(info.getValue())}
        </span>
      ),
    }),
    columnHelper.accessor("qtyTo", {
      id: "qtyTo",
      header: "To qty",
      size: 100,
      enableSorting: false,
      cell: (info) => (
        <span className="font-mono tabular-nums">
          {qtyDisplay(info.getValue())}
        </span>
      ),
    }),
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: "When",
      size: 170,
      cell: (info) =>
        new Date(info.getValue()).toLocaleString("en-PH", {
          timeZone: "Asia/Manila",
        }),
    }),
  ]);
}
